import React from 'react'
import {
  Card as ShadcnCard,
  CardHeader as ShadcnCardHeader,
  CardContent as ShadcnCardContent,
  CardFooter as ShadcnCardFooter,
  CardTitle as ShadcnCardTitle,
} from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <ShadcnCard ref={ref} className={cn(className)} {...props} />
  ),
)
Card.displayName = 'Card'

export const CardHeader = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <ShadcnCardHeader ref={ref} className={cn(className)} {...props} />
  ),
)
CardHeader.displayName = 'CardHeader'

export const CardBody = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <ShadcnCardContent ref={ref} className={cn(className)} {...props} />
  ),
)
CardBody.displayName = 'CardBody'

export const CardFooter = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <ShadcnCardFooter ref={ref} className={cn(className)} {...props} />
  ),
)
CardFooter.displayName = 'CardFooter'

export const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <ShadcnCardTitle ref={ref} className={cn(className)} {...props} />
  ),
)
CardTitle.displayName = 'CardTitle'

export const CardText: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({ className, ...props }) => (
  <p className={cn('text-sm text-muted-foreground', className)} {...props} />
)
